import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class EtiquetaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    protected config: ConfigService
    ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'etiqueta'].join('/');
  }

  getByOrganizacion(organizacionId: string): any {
    return this.http
      .get(`${this.config.getApiUrl()}/organizacion/${organizacionId}/etiqueta`)
      .map(res => res.json());
}

  // public consultarPorOrganizacion(id_org) {
  //   console.log("DATA ID:", id_org);
  //   return this.http
  //   .get([this.ApiUrl,'organizacion',id_org].join('/'))
  //   .map(res => res.json());
  // }



}



// WEBPACK FOOTER //
// ./src/app/services/etiqueta/etiqueta.service.ts